import { render, staticRenderFns } from "./mxXhm.vue?vue&type=template&id=4105bd27&"
import script from "./mxXhm.vue?vue&type=script&lang=js&"
export * from "./mxXhm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports